import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../api";

export const fetchOutboundSmsWorkspaces = createAsyncThunk(
  "outboundSms/fetchWorkspaces",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.manageUser.getOutboundSmsWorkspacesWithFields();
      if (!res?.status) {
        return rejectWithValue("Failed to load outbound SMS workspaces");
      }
      if (!Array.isArray(res.data)) {
        return [];
      }
      return res.data
        .filter((ws) => ws?.workspace_id && ws?.workspace_name)
        .map((ws) => ({
          ...ws,
          parsed_fields: Array.isArray(ws.parsed_fields)
            ? ws.parsed_fields.filter((f) => f?.key?.trim())
            : [],
        }));
    } catch (err) {
      return rejectWithValue(err.message || "Unknown error occurred");
    }
  }
);

const initialState = {
  enabled: false,
  workspaces: [],
  selectedWorkspaces: [],
  parsedFields: {},
  selectedValues: {},
  requiredSettings: {},
};

const outboundSmsSlice = createSlice({
  name: "outboundSms",
  initialState,
  reducers: {
    toggleOutboundSms(state, action) {
      state.enabled = action.payload;
    },
    setSmsWorkspaces(state, action) {
      state.selectedWorkspaces = action.payload;
      Object.keys(state.parsedFields).forEach((wsId) => {
        if (!action.payload.includes(Number(wsId))) {
          delete state.parsedFields[wsId];
          delete state.selectedValues[wsId];
          delete state.requiredSettings[wsId];
        }
      });
    },
    setSmsParsedFields(state, action) {
      const { workspaceId, fields } = action.payload;
      state.parsedFields[workspaceId] = fields;
      const sv = state.selectedValues[workspaceId];
      if (sv) {
        Object.keys(sv).forEach((fieldKey) => {
          if (!fields.includes(fieldKey)) delete sv[fieldKey];
        });
      }
    },
    setSmsSelectedValues(state, action) {
      const { workspaceId, field, values } = action.payload;
      if (!state.selectedValues[workspaceId]) {
        state.selectedValues[workspaceId] = {};
      }
      state.selectedValues[workspaceId][field] = values;
    },
    setSmsRequiredSetting(state, action) {
      const { workspaceId, value } = action.payload;
      state.requiredSettings[workspaceId] = value;
    },
    hydrateOutboundSms(state, action) {
      return { ...state, ...action.payload };
    },
    resetOutboundSms() {
      return { ...initialState };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchOutboundSmsWorkspaces.fulfilled, (state, action) => {
      state.workspaces = action.payload;
    });
  },
});

export const {
  toggleOutboundSms,
  setSmsWorkspaces,
  setSmsParsedFields,
  setSmsSelectedValues,
  setSmsRequiredSetting,
  hydrateOutboundSms,
  resetOutboundSms,
} = outboundSmsSlice.actions;

export default outboundSmsSlice.reducer;
